// This React component, `BeginnerGolfPage`, is a Next.js client component designed to render the Beginner
// Golf landing page. It retrieves data from the `dataSource` within the `data` prop and passes
// it to the `BeginnerGolf` component for display. By using `TasticProps<BeginnerGolfDataProps>`,
// it ensures type safety and structured data management. This setup enables efficient and dynamic
// content rendering for the Beginner Golf page.
'use client';

import React from 'react';
import { TasticProps } from '../types';
import BeginnerGolf from 'components/commercetools-ui/organisms/landing-pages/beginner-golf';
import { useBadgeLoader } from 'helpers/utils/badgeLoader';
import { P2Badge } from 'components/commercetools-ui/organisms/product/product-list-algolia/types';

const BeginnerGolfPage = ({ data }: TasticProps<any>) => {
  const beginnerGolfData = data?.data?.dataSource?.payload;
  const p1BadgeData = data?.data?.dataSource?.p1BadgeData;
  const p2BadgeData = data?.data?.dataSource?.p2BadgeData;
  const p1Badges = useBadgeLoader(p1BadgeData?.productListingContent);
  const p2Badges = p2BadgeData?.productListingContent as P2Badge[];

  return (
    <>
      <BeginnerGolf beginnerGolf={beginnerGolfData} p1BadgeData={p1Badges} p2BadgeData={p2Badges} />
    </>
  );
};

export default BeginnerGolfPage;
